module.exports = __webpack_public_path__ + "static/media/copy-shopping-list.6dc5bea5.png";